// extracted by mini-css-extract-plugin
module.exports = {"sup":"styles_sup__zkf8J","disclosureWrap":"styles_disclosureWrap__4DFPi","disclosureToggleBtn":"styles_disclosureToggleBtn__XPF9z"};